import { Component } from "@theme/component";

/**
 * @typedef {Object} VolumePricingRefs
 * @property {HTMLButtonElement} [volumePricingToggle] - Expands and collapses the additional pricing tiers.
 */

/**
 * Displays volume pricing table with expandable rows.
 * Shows pricing tiers based on quantity thresholds.
 *
 * @extends {Component<VolumePricingRefs>}
 */
class VolumePricingComponent extends Component {
  /**
   * Toggles the expanded state of the volume pricing table
   */
  toggleExpanded() {
    const isExpanded = this.classList.toggle("volume-pricing--expanded");
    this.refs.volumePricingToggle?.setAttribute("aria-expanded", String(isExpanded));
  }
}

if (!customElements.get("volume-pricing")) {
  customElements.define("volume-pricing", VolumePricingComponent);
}
